import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AtualizacoesProaAudit } from '../models/atualizacoes-proa-audit';

@Injectable({
  providedIn: 'root'
})
export class AtualizacoesProaAuditService extends BaseService<AtualizacoesProaAudit> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/audit-proa';
  }

  public getAtualizacoes(obj: Object = null): Observable<AtualizacoesProaAudit[]> {
    return this.http.post<AtualizacoesProaAudit[]>(this.baseUrl + '/atualizacoes', obj, { headers: this.headers });
  }

}